import { INoteViewMediaSyncManagerInjectable, PlayerType } from '@src/slide/application/service/note-view-media-sync-manager/core/note-view-media-sync-manager.interface';
import SyncElementKey from '../core/sync-element-key';

export class NoteViewMediaSyncManagerInjectable implements INoteViewMediaSyncManagerInjectable {
    public attachMediaEvent = (mediaInstance, mediaId: string, playerType: PlayerType): boolean => {
        if (playerType !== PlayerType.DESKTOP) return false;
        /**
        * 同一player实例对应的多mediaInstance使用同一套events事件系统
        * 所以一个窗口内播放器显隐emit的事件其他窗口也能监听到，不需要单独的多窗口同步消息
        */
        mediaInstance?.onContainerState((isShow) => {
            // 显隐状态发生改变后通过updatePlayerElementKey同步播放器
            if (mediaInstance.isShow !== isShow) {
                const { pictureModelKey } = SyncElementKey.findMediaById(mediaId) || {};
                if (!pictureModelKey) {
                    return;
                }
                SyncElementKey.updateElementKey(isShow ? pictureModelKey : '');
            }
        });
        return true;
    };
}
